import React, {Component} from 'react';
import FavoritesResults from './parts/FavoritesResults';
import AppHeader from './parts/AppHeader';
import Axios from 'axios';
import APIENDPOINT from "./ApiEndpoint";

class Favorites extends Component {
    constructor(props){
        super(props);
        this.state = {
            favorites: []
        }
    }
    componentDidMount(){
        Axios.get(`${APIENDPOINT}/mcard`)
            .then(response => {
            const {data} = response;
            const mcards = Object.values(data);
            let favorites = [];

            function parseLocalStorageArray(localStorageItemName){
                return localStorage.getItem(localStorageItemName).split("&").slice(0, -1);
            }

            mcards.forEach(mcard => {
                if(parseLocalStorageArray('favorites').includes(String(mcard.id))){
                    favorites.push(mcard);
                }
            });

            this.setState({favorites});
        })
        .catch(err => {
            console.log(err);
        })
    }
    render(){
        return(
            <div>
                <AppHeader leftButton='Back' titleText='Favorieten' titleTextLink='/' rightButton=''/>
                <FavoritesResults mcards={this.state.favorites} />
            </div>
        )
    }
}

export default Favorites;